const PROFILE_PREFIX = '@@profile/';

export const PROFILE_ACTION_TYPES = {
    SET_PROFILE_FIELDS: `${PROFILE_PREFIX}SET_PROFILE_FIELDS`,
    SET_PROFILE_FIELD: `${PROFILE_PREFIX}SET_PROFILE_FIELD`,
    RESET_PROFILE_FIELDS: `${PROFILE_PREFIX}RESET_PROFILE_FIELDS`,
    SET_ACTIVE_SECTION: `${PROFILE_PREFIX}SET_ACTIVE_SECTION`,

    // API actions
    REQUEST_SAVE_PROFILE: `${PROFILE_PREFIX}REQUEST_SAVE_PROFILE`,
    SAVE_PROFILE_SUCCESS: `${PROFILE_PREFIX}SAVE_PROFILE_SUCCESS`,
    SAVE_PROFILE_ERROR: `${PROFILE_PREFIX}SAVE_PROFILE_ERROR`,

    REQUEST_LOAD_PROFILE: `${PROFILE_PREFIX}REQUEST_LOAD_PROFILE`,
    LOAD_PROFILE_SUCCESS: `${PROFILE_PREFIX}LOAD_PROFILE_SUCCESS`,
    LOAD_PROFILE_ERROR: `${PROFILE_PREFIX}LOAD_PROFILE_ERROR`,

    REQUEST_CHANGE_PASSWORD: `${PROFILE_PREFIX}REQUEST_CHANGE_PASSWORD`,
    CHANGE_PASSWORD_SUCCESS: `${PROFILE_PREFIX}CHANGE_PASSWORD_SUCCESS`,
    CHANGE_PASSWORD_ERROR: `${PROFILE_PREFIX}CHANGE_PASSWORD_ERROR`,

    REQUEST_ORDERS: `${PROFILE_PREFIX}REQUEST_ORDERS`,
    RECEIVE_ORDERS: `${PROFILE_PREFIX}RECEIVE_ORDERS`,
    ORDERS_ERROR: `${PROFILE_PREFIX}ORDERS_ERROR`,

    REQUEST_SERVICES: `${PROFILE_PREFIX}REQUEST_SERVICES`,
    RECEIVE_SERVICES: `${PROFILE_PREFIX}RECEIVE_SERVICES`,
    SERVICES_ERROR: `${PROFILE_PREFIX}SERVICES_ERROR`,

    REQUEST_DOCUMENTS: `${PROFILE_PREFIX}REQUEST_DOCUMENTS`,
    RECEIVE_DOCUMENTS: `${PROFILE_PREFIX}RECEIVE_DOCUMENTS`,
    DOCUMENTS_ERROR: `${PROFILE_PREFIX}DOCUMENTS_ERROR`,
};

export const PROFILE_FIELD_NAMES = {
    LOGIN: 'login',
    DISPLAY_NAME: 'displayName',

    COUNTRY: 'country',
    REGION: 'region',
    CITY: 'city',
    POSTAL_CODE: 'postalCode',
    ADDRESS: 'address',

    FIRSTNAME: 'firstName',
    LASTNAME: 'lastName',
    PHONE_COUNTRY: 'phoneCountry',
    PHONE: 'phone',
    EMAIL: 'email',

    IS_JURIDIC: 'isJuridic',
    COMPANY: 'companyName',
    COMPANY_INN: 'companyInn',
    COMPANY_KPP: 'companyKpp',
    COMPANY_OGRN: 'companyOgrn',
    COMPANY_CHIEF_NAME: 'companyChiefName',
    COMPANY_CONTACT_NAME: 'companyContactName',
    COMPANY_JOB_TITLE: 'companyJobTitle',
    COMPANY_SCOPE: 'companyScope',
    COMPANY_LEGAL_ADDR: 'companyLegalAddress',
    COMPANY_POST_ADDR: 'companyPostAddress',
};

export const PROFILE_SECTIONS = {
    PERSONAL_DATA: 'personal-data',
    ORDERS: 'orders',
    SERVICES: 'services',
    DOCUMENTS: 'documents',
};
